import { API_BASE_URL } from "../config";

import { session } from "./session";



export class ApiError extends Error {

  statusCode?: number;

  body?: unknown;



  constructor(message: string, statusCode?: number, body?: unknown) {

    super(message);

    this.name = "ApiError";

    this.statusCode = statusCode;

    this.body = body;

  }

}



export type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";



export interface ApiRequestOptions {

  method?: HttpMethod;

  body?: unknown;

  /** Attach Bearer token when available (default: true). */

  auth?: boolean;

  /** Override Bearer token (e.g. 2FA verify token). */

  bearerToken?: string;

}



function buildUrl(path: string): string {

  if (path.startsWith("http://") || path.startsWith("https://")) {

    return path;

  }

  const normalized = path.startsWith("/") ? path : `/${path}`;

  return `${API_BASE_URL}${normalized}`;

}



function extractErrorMessage(data: unknown, fallback: string): string {

  if (data && typeof data === "object") {

    const record = data as Record<string, unknown>;

    if (typeof record.message === "string") {

      return record.message;

    }

    if (typeof record.error === "string") {

      return record.error;

    }

    const nested = record.error as Record<string, unknown> | undefined;

    if (nested && typeof nested.message === "string") {

      return nested.message;

    }

  }

  return fallback;

}



/**

 * HTTP client for the Procxo API gateway.

 */

export async function apiRequest<T = unknown>(

  path: string,

  options: ApiRequestOptions = {}

): Promise<T> {

  const { method = "GET", body, auth = true, bearerToken } = options;



  const headers: Record<string, string> = {

    "Content-Type": "application/json",

  };



  if (bearerToken) {

    headers.Authorization = `Bearer ${bearerToken}`;

  } else if (auth) {

    const token = session.getAccessToken();

    if (token) {

      headers.Authorization = `Bearer ${token}`;

    }

  }



  const response = await fetch(buildUrl(path), {

    method,

    headers,

    body: body !== undefined ? JSON.stringify(body) : undefined,

  });



  const text = await response.text();

  let data: unknown = null;

  if (text) {

    try {

      data = JSON.parse(text);

    } catch {

      data = text;

    }

  }



  if (!response.ok) {

    throw new ApiError(

      extractErrorMessage(data, response.statusText || "Request failed"),

      response.status,

      data

    );

  }



  return data as T;

}



export function getApiBaseUrl(): string {

  return API_BASE_URL;

}

